import type { ReconciliationStatus, ReconciliationSource, ReconciliationRowFieldsVO, ReconciliationFieldVO } from '../../../apis/types'

export function displayString(field: ReconciliationFieldVO | undefined): string | null {
    if (!field) return null
    const v = field.display
    return v == null ? null : String(v)
}

interface StatusStyle {
    bg: string
    text: string
    label: string
}

export const statusStyles: Record<ReconciliationStatus, StatusStyle> = {
    exact: { bg: 'bg-green-50 dark:bg-green-900/20', text: 'text-green-800 dark:text-green-300', label: 'Match' },
    fuzzy: { bg: 'bg-yellow-50 dark:bg-yellow-900/20', text: 'text-yellow-800 dark:text-yellow-300', label: 'Fuzzy Match' },
    mismatch: { bg: 'bg-orange-50 dark:bg-orange-900/20', text: 'text-orange-800 dark:text-orange-300', label: 'Mismatch' },
    missing: { bg: 'bg-red-50 dark:bg-red-900/20', text: 'text-red-800 dark:text-red-300', label: 'Missing' },
    sourceUnavailable: { bg: 'bg-slate-100 dark:bg-slate-700/50', text: 'text-slate-500 dark:text-slate-400', label: 'N/A' },
}

export const sourceDisplayNames: Record<ReconciliationSource, string> = {
    utilityPortal: 'Utility Portal',
    salesforce: 'Salesforce',
    admin: 'Admin',
}

interface FieldColumnConfig {
    label: string
    fieldKey: keyof ReconciliationRowFieldsVO
    authoritativeSource: ReconciliationSource
}

export const fieldColumns: FieldColumnConfig[] = [
    { label: 'Service ID', fieldKey: 'serviceId', authoritativeSource: 'utilityPortal' },
    { label: 'Tariff / Rate', fieldKey: 'tariffRate', authoritativeSource: 'admin' },
    { label: 'Statement Due Date', fieldKey: 'lastStmtDueDate', authoritativeSource: 'utilityPortal' },
    { label: 'Last Statement', fieldKey: 'lastStmtDate', authoritativeSource: 'utilityPortal' },
    { label: 'Last Payment', fieldKey: 'lastPaymentDate', authoritativeSource: 'utilityPortal' },
    { label: 'Service Address', fieldKey: 'serviceAddress', authoritativeSource: 'admin' },
    { label: 'Billing Address', fieldKey: 'billingAddress', authoritativeSource: 'utilityPortal' },
    { label: 'VNEM Allocation', fieldKey: 'vnemPct', authoritativeSource: 'salesforce' },
    { label: 'PMA Approved', fieldKey: 'pmaApproved', authoritativeSource: 'salesforce' },
    { label: 'On Active Table', fieldKey: 'onActiveTable', authoritativeSource: 'salesforce' },
    { label: 'VA Table Status', fieldKey: 'vaTableStatus', authoritativeSource: 'salesforce' },
    { label: 'Scraper', fieldKey: 'scraperLinked', authoritativeSource: 'admin' },
    { label: 'Autopay', fieldKey: 'autopay', authoritativeSource: 'utilityPortal' },
    { label: 'Payment Status', fieldKey: 'paymentStatus', authoritativeSource: 'utilityPortal' },
]

export const vnemSeverityColors: Record<string, { bg: string; text: string }> = {
    ok: { bg: 'bg-green-100 dark:bg-green-900/30', text: 'text-green-800 dark:text-green-300' },
    warning: { bg: 'bg-yellow-100 dark:bg-yellow-900/30', text: 'text-yellow-800 dark:text-yellow-300' },
    critical: { bg: 'bg-red-100 dark:bg-red-900/30', text: 'text-red-800 dark:text-red-300' },
    unavailable: { bg: 'bg-slate-100 dark:bg-slate-700/50', text: 'text-slate-500 dark:text-slate-400' },
}

export const issueColorKeyStyles: Record<string, { bg: string; text: string; ring: string }> = {
    green: { bg: 'bg-green-50 dark:bg-green-400/10', text: 'text-green-700 dark:text-green-400', ring: 'ring-green-600/20 dark:ring-green-400/20' },
    yellow: { bg: 'bg-yellow-50 dark:bg-yellow-400/10', text: 'text-yellow-700 dark:text-yellow-400', ring: 'ring-yellow-600/20 dark:ring-yellow-400/20' },
    orange: { bg: 'bg-orange-50 dark:bg-orange-400/10', text: 'text-orange-700 dark:text-orange-400', ring: 'ring-orange-600/20 dark:ring-orange-400/20' },
    red: { bg: 'bg-red-50 dark:bg-red-400/10', text: 'text-red-700 dark:text-red-400', ring: 'ring-red-600/20 dark:ring-red-400/20' },
    gray: { bg: 'bg-gray-50 dark:bg-gray-400/10', text: 'text-gray-700 dark:text-gray-400', ring: 'ring-gray-600/20 dark:ring-gray-400/20' },
}
